import React, { useEffect, useState } from 'react';

import { Box } from '@mui/joy';
import ButtonAttribute from '../../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../../Components/TableData';
import { Switch, Checkbox, createTheme, Divider, FormControlLabel, Grid, ThemeProvider, Typography } from '@mui/material';
import BasicModal from '../../Components/BasicModel';
import axios from 'axios';
import { API } from '../../API/api';
import TextInputMui from '../../Components/TextInputMui';
import AlertBar from '../../Components/AlertBar';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../../Components/CustomizedProgressBars';
import { logOperation } from '../../API/logOperation';
import AutocompleteComboBox from '../../Components/AutocompleteComboBox';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});

export default function Chauffeurs() {
  const [isLoading, setIsLoading] = useState(0);
  const [importStatus, setImportStatus] = useState("idle");
  const [Chauffeurs, setChauffeurs] = useState([]);
  const [openAjouterChauffeur, setOpenAjouterChauffeur] = React.useState(false);
  const [rowsSelected, setRowsSelected] = React.useState({});
  const handleOpen = () => setOpenAjouterChauffeur(true);
  const handleClose = () => setOpenAjouterChauffeur(false);
  const [Permissions, setPermissions] = useState([]);
  const [role, setRole] = useState([]);

  const [openModifierChauffeur, setOpenModifierChauffeur] = React.useState(false);
  const handleOpenModifier = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenModifierChauffeur(true);
      setRowsSelected(selectedRows);
      setModifierChauffeur(selectedRows[0]);
    } else setAlertOpenSelectedModifier(true);
  };
  const handleCloseModifier = () => setOpenModifierChauffeur(false);

  const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
  const handleAlertCloseSelectedModifier = () => { setAlertOpenSelectedModifier(false); };
  const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
  const handleAlertCloseNotModiferRow = () => { setAlertOpenNotModiferRow(false); };
  const handleAlertOpenNotModiferRow = () => { setAlertOpenNotModiferRow(true); };
  const [alertOpenUpdatedChauffeur, setAlertOpenUpdatedChauffeur] = useState(false);
  const handleAlertCloseUpdatedChauffeur = () => { setAlertOpenUpdatedChauffeur(false); };
  const handleAlertOpenUpdatedChauffeur = () => { setAlertOpenUpdatedChauffeur(true); };

  const handleOpenModifierOneChauffeur = async () => {
    // guard selected row
    const base = rowsSelected?.[0] || {};

    // unchanged check
    const same =
      base.Nom === modifierChauffeur.Nom &&
      base.Prénom === modifierChauffeur.Prénom &&
      base.Numéro_permis === modifierChauffeur.Numéro_permis &&
      base.Contact === modifierChauffeur.Contact &&
      Number(base.Disponibilité) === Number(modifierChauffeur.Disponibilité) &&
      (base.Date_de_naissance || "") === (modifierChauffeur.Date_de_naissance || "") &&
      base.Type_de_permis === modifierChauffeur.Type_de_permis &&
      base.Numéro_de_CIN === modifierChauffeur.Numéro_de_CIN &&
      (base.Adresse || "") === (modifierChauffeur.Adresse || "") &&
      (base.adresse2 || "") === (modifierChauffeur.adresse2 || "") &&
      (base.Contact2 || "") === (modifierChauffeur.Contact2 || "");

    if (same) {
      handleAlertOpenNotModiferRow();
      return;
    }

    // validation: required fields with message
    const isEmpty = (v) => v == null || String(v).trim() === "";
    const REQUIRED = [
      { key: "Nom", label: "Nom" },
      { key: "Prénom", label: "Prénom" },
      { key: "Numéro_permis", label: "Numéro de permis" },
      { key: "Type_de_permis", label: "Type de permis" },
      { key: "Numéro_de_CIN", label: "Numéro de CIN" },
    ];
    const missing = REQUIRED.filter((f) => isEmpty(modifierChauffeur[f.key])).map((f) => f.label);

    if (missing.length > 0) {
      setErrorsModifer({
        error: true,
        message: `Champs obligatoires manquants: ${missing.join(", ")}`,
      });
      return;
    }

    try {
      const storedAuthState = sessionStorage.getItem("authLocalstorage");
      const parsedAuthState = JSON.parse(storedAuthState);
      const ID = modifierChauffeur.id;

      await axios.put(
        `${API}/chauffeurs/${ID}`,
        {
          Nom: modifierChauffeur.Nom,
          Prénom: modifierChauffeur.Prénom,
          Numéro_permis: modifierChauffeur.Numéro_permis,
          Contact: modifierChauffeur.Contact,
          Disponibilité: Number(modifierChauffeur.Disponibilité) ? 1 : 0,
          Date_de_naissance: modifierChauffeur.Date_de_naissance || null,
          Type_de_permis: modifierChauffeur.Type_de_permis,
          Numéro_de_CIN: modifierChauffeur.Numéro_de_CIN,
          Adresse: modifierChauffeur.Adresse || null,
          adresse2: modifierChauffeur.adresse2 || null,
          Contact2: modifierChauffeur.Contact2 || null,
        },
        { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }
      );

      setErrorsModifer({ error: false, message: "" });
      handleAlertOpenUpdatedChauffeur();
      handleCloseModifier();
      fetchChauffeurs(parsedAuthState.token);
      logOperation({
        operation_type: "UPDATE",
        entity_type: "chauffeurs",
        entity_id: parsedAuthState.user.id,
        description: "Modifier chauffeur",
      });
    } catch (error) {
      setErrorsModifer({
        error: true,
        message: error?.response?.data?.message || "Erreur lors de la mise à jour",
      });
      console.error("Update error:", error?.response?.data || error.message);
    }
  };


  const [errors, setErrors] = useState(false);
  const [errorsModifer, setErrorsModifer] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const handleAlertClose = () => { setAlertOpen(false); };
  const maxDob = dayjs().subtract(18, 'year').format('YYYY-MM-DD');
  const [newChauffeur, setNewChauffeur] = useState({
    Nom: '',
    Prénom: '',
    Numéro_permis: '',
    Contact: '',
    Disponibilité: 0,
    Date_de_naissance: maxDob,
    Type_de_permis: '',
    Numéro_de_CIN: '',
    Adresse: '',
    adresse2: '',
    Contact2: '',
  });

  const [modifierChauffeur, setModifierChauffeur] = useState({
    Nom: '',
    Prénom: '',
    Numéro_permis: '',
    Contact: '',
    Disponibilité: 0,
    Date_de_naissance: '',
    Type_de_permis: '',
    Numéro_de_CIN: '',
    Adresse: '',
    adresse2: '',
    Contact2: '',
  });
  // near top of file
  const typesPermisMA = [
    { id: 'AM', Nom: 'AM — Cyclomoteur ≤50cc' },
    { id: 'A1', Nom: 'A1 — Moto ≤125cc' },
    { id: 'A', Nom: 'A — Moto' },
    { id: 'B', Nom: 'B — Véhicule ≤3,5 t' },
    { id: 'C1', Nom: 'C1 — Camion 3,5–7,5 t' },
    { id: 'C', Nom: 'C — Camion >7,5 t' },
    { id: 'D1', Nom: 'D1 — Minibus ≤17 places' },
    { id: 'D', Nom: 'D — Autobus' },
    { id: 'EB', Nom: 'EB — B + remorque' },
    { id: 'EC1', Nom: 'EC1 — C1 + remorque' },
    { id: 'EC', Nom: 'EC — C + remorque' },
    { id: 'ED1', Nom: 'ED1 — D1 + remorque' },
    { id: 'ED', Nom: 'ED — D + remorque' },
  ];
  const [alertOpenDeletedChauffeur, setAlertOpenDeletedChauffeur] = useState(false);
  const handleAlertCloseDeletedChauffeur = () => { setAlertOpenDeletedChauffeur(false); };
  const handleAlertOpenDeletedChauffeur = () => { setAlertOpenDeletedChauffeur(true); };
  const [alertOpenMultiDeletedChauffeur, setAlertMultiOpenDeletedChauffeur] = useState(false);
  const handleAlertMultiCloseDeletedChauffeur = () => { setAlertMultiOpenDeletedChauffeur(false); };
  const handleAlertMultiOpenDeletedChauffeur = () => { setAlertMultiOpenDeletedChauffeur(true); };
  const [openDeleteChauffeur, setOpenDeleteChauffeur] = useState(false);
  const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
  const handleAlertClosePasswordNotValid = () => { setAlertOpenPasswordNotValid(false); };
  const handleAlertOpenPasswordNotValid = () => { setAlertOpenPasswordNotValid(true); };
  const handleOpenDeleteChauffeur = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenDeleteChauffeur(true);
      setRowsSelected(selectedRows);
      setModifierChauffeur(selectedRows[0]);
    } else setAlertOpenSelectedModifier(true);
  };
  const handleCloseDeleteChauffeur = () => { setOpenDeleteChauffeur(false); };

  const handleDeleteChauffeur = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const ID = modifierChauffeur.id;

    try {
      await axios.delete(`${API}/chauffeurs/${ID}`, {
        headers: { Authorization: `Bearer ${parsedAuthState.token}` }
      });
      handleCloseDeleteChauffeur();
      setAlertOpenDeletedChauffeur(true);
      logOperation({
        operation_type: "DELETE",
        entity_type: "chauffeurs",
        entity_id: parsedAuthState.user.id,
        description: "Supprimer chauffeur",
      });
    } catch (error) {
      console.error('Delete error:', error?.response?.data || error.message);
    }
  };

  const handleDeleteMultiChauffeurs = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    try {
      const promises = rowsSelected.map((row) =>
        axios.delete(`${API}/chauffeurs/${row.id}`, {
          headers: { Authorization: `Bearer ${parsedAuthState.token}` }
        })
      );
      await Promise.all(promises);
      handleCloseDeleteChauffeur();
      handleAlertMultiOpenDeletedChauffeur();
      logOperation({
        operation_type: "DELETE MULTIPLE",
        entity_type: "chauffeurs",
        entity_id: parsedAuthState.user.id,
        description: "Supprimer chauffeurs",
      });
    } catch (error) {
      console.error('Delete multi error:', error?.response?.data || error.message);
    }
  };

  const handleVerificationPassword = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const email = parsedAuthState.user.email;
    const password = ConfrimedPassword.password;

    axios
      .post(`${API}/verify-password`, { email, password })
      .then((response) => {
        if (response.data.success) {
          if (rowsSelected.length === 1) handleDeleteChauffeur();
          else handleDeleteMultiChauffeurs();
          handleCloseConfirmationPassword();
          fetchChauffeurs(parsedAuthState.token);
        } else {
          setConfirmedPassword({ errors: true });
          handleAlertOpenPasswordNotValid();
        }
      })
      .catch(() => {
        setConfirmedPassword({ errors: true });
        handleAlertOpenPasswordNotValid();
      });
  };

  const [openExtrationChauffeur, setOpenExtrationChauffeur] = useState(false);
  const handleCloseExtrationChauffeur = () => { setOpenExtrationChauffeur(false); };
  const handleOpenExtrationChauffeur = () => { setOpenExtrationChauffeur(true); };
  const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
  const handleAlertOpenNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(true); };
  const handleAlertCloseNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(false); };

  const handleExtrationAllChauffeur = () => {
    if (!Chauffeurs || Chauffeurs.length === 0) return;

    const formattedData = Chauffeurs.map((chauffeur) => {
      const newRow = {};

      columns.forEach((col) => {
        newRow[col.header] = chauffeur[col.accessorKey] ?? "";
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Chauffeurs");

    XLSX.writeFile(workbook, "Chauffeurs.xlsx");

    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState);

    logOperation({
      operation_type: "Extraction",
      entity_type: "chauffeurs",
      entity_id: parsedAuthState.user.id,
      description: "Extraction chauffeurs",
    });
  };

  const handleExtrationSelectionsChauffeurs = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows && selectedRows.length > 0) {
      const csvRows = [];
      const headers = columns.map((col) => col.header);
      csvRows.push(headers.join(","));
      selectedRows.forEach((Chauffeur) => {
        const row = columns.map((col) => {
          const value = Chauffeur[col.accessorKey];
          return `"${value ?? ""}"`;
        });
        csvRows.push(row.join(","));
      });
      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "Chauffeurs.csv");
      logOperation({
        operation_type: "Extraction",
        entity_type: "chauffeurs",
        entity_id: parsedAuthState.user.id,
        description: "Extraction chauffeurs",
      });
    } else handleAlertOpenNotSelectedLineExtration();
  };
  const [openImportationChauffeur, setOpenImportationChauffeur] = useState(false);
  const handleCloseImportationChauffeur = () => { setOpenImportationChauffeur(false); };
  const handleOpenImportationChauffeur = () => { setOpenImportationChauffeur(true); };
  const [alertOpenImport, setAlertOpenImport] = useState(false);
  const handleAlertOpenImport = () => { setAlertOpenImport(true); };
  const handleCloseAlertImport = () => { setAlertOpenImport(false); };
  const [alertErrorImport, setAlertErrorImport] = useState(false);
  const handleOpenErrorAlertImport = () => { setAlertErrorImport(true); };
  const handleCloseErrorAlertImport = () => { setAlertErrorImport(false); };

  const handleDownload = () => {
    const filePath = `/ImportChauffeurs.xlsx`;
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'ImportChauffeurs.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const triggerFileInput = () => document.getElementById("file-upload").click();

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState || "{}");
    const token = parsedAuthState?.token;

    reader.onload = async (e) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: "binary" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        if (!jsonData.length) {
          toast.error("Le fichier est vide.");
          return;
        }

        /* ===============================
           REQUIRED COLUMNS CHECK
        =============================== */

        const requiredColumns = ["Nom", "Prénom", "Numéro permis", "Contact"];

        const fileColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredColumns.filter(
          (col) => !fileColumns.includes(col)
        );

        if (missingColumns.length > 0) {
          toast.error(
            `Colonnes obligatoires manquantes : ${missingColumns.join(", ")}`
          );
          return;
        }

        /* ===============================
           VALIDATE ROWS
        =============================== */

        const validRows = [];
        const invalidRows = [];

        jsonData.forEach((row, index) => {
          const missing = requiredColumns.filter(
            (col) => !row[col] || String(row[col]).trim() === ""
          );

          if (missing.length) {
            invalidRows.push(index + 2);
          } else {
            validRows.push({ row, line: index + 2 });
          }
        });

        if (invalidRows.length > 0) {
          toast.error(
            `Import annulé. Champs obligatoires manquants aux lignes : ${invalidRows.join(", ")}`
          );
          return;
        }

        /* ===============================
           START INSERT
        =============================== */

        setIsLoading(0);
        setImportStatus("processing");

        let successCount = 0;
        let failedCount = 0;
        const successLines = [];
        const failedLines = [];

        const normDate = (v) => {
          if (!v) return null;
          if (typeof v === "number") {
            const d = XLSX.SSF.parse_date_code(v);
            const mm = String(d.m).padStart(2, "0");
            const dd = String(d.d).padStart(2, "0");
            return `${d.y}-${mm}-${dd}`;
          }
          const d = new Date(v);
          return Number.isNaN(d.getTime())
            ? null
            : d.toISOString().slice(0, 10);
        };

        for (let i = 0; i < validRows.length; i++) {
          const { row, line } = validRows[i];

          try {
            await axios.post(
              `${API}/chauffeurs`,
              {
                Nom: row["Nom"],
                Prénom: row["Prénom"],
                Numéro_permis: row["Numéro permis"],
                Contact: String(row["Contact"] ?? ""),
                Disponibilité: row["Disponibilité"] ? 1 : 0,
                Date_de_naissance: normDate(row["Date de naissance"]),
                Type_de_permis: row["Type de permis"] || "",
                Numéro_de_CIN: row["Numéro de CIN"] || "",
                Adresse: row["Adresse"] || "",
                adresse2: row["Adresse 2"] || "",
                Contact2: String(row["Contact 2"] || ""),
              },
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );

            successCount++;
            successLines.push(line);
          } catch (error) {
            failedCount++;
            failedLines.push(line);
            console.error("Erreur ligne", line, error);
          }

          setIsLoading(((i + 1) / validRows.length) * 100);
        }

        /* ===============================
           FINAL RESULT
        =============================== */

        if (failedCount > 0) {
          setImportStatus("error");

          toast.error(
            `Import terminé.

✅ Succès : ${successCount}
❌ Échecs : ${failedCount}

Lignes insérées : ${successLines.join(", ") || "Aucune"}
Lignes échouées : ${failedLines.join(", ") || "Aucune"}`
          );
        } else {
          setImportStatus("success");

          toast.success(
            `Importation réussie !

${successCount} chauffeur(s) ajouté(s)
Lignes : ${successLines.join(", ")}`
          );
        }

        fetchChauffeurs(token);

        logOperation({
          operation_type: "Importation",
          entity_type: "chauffeurs",
          entity_id: parsedAuthState.user?.id,
          description: "Importation chauffeurs",
        });

        setTimeout(() => {
          setIsLoading(0);
          setImportStatus("idle");
        }, 4000);

      } catch (err) {
        console.error("Erreur globale import:", err);
        setImportStatus("error");
        toast.error("Erreur inattendue pendant l'import.");
        setIsLoading(0);
      }
    };

    reader.readAsBinaryString(file);
  };

  const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);
  const handleCloseConfirmationPassword = () => { setOpenConfirmationPassword(false); };
  const handleOpenConfirmationPassword = () => { setOpenConfirmationPassword(true); };
  const [ConfrimedPassword, setConfirmedPassword] = useState({ password: "", errors: "" });
  const [alertOpenConfirmDeleteChauffeur, setAlertOpenConfirmDeleteChauffeur] = useState(false);
  const handleAlertOpenConfirmDeleteChauffeur = () => { setAlertOpenConfirmDeleteChauffeur(true); };
  const handleCloseAlertConfirmDeleteChauffeur = () => { setAlertOpenConfirmDeleteChauffeur(false); };

  const optionsTypeVoyage = [
    { value: 'National', label: 'National' },
    { value: 'International', label: 'International' },
    { value: 'International + National', label: 'International + National' },
  ];

  const MenuButton = () => (
    <Box sx={{
      backgroundColor: '#ffffff',
      border: '1px solid #e5e7eb4b',
      borderRadius: '32px',
      padding: { xs: '20px', md: '30px' },
      marginBottom: '20px',
      boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
    }}>

      {/* Header Section */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Box sx={{
            width: '40px',
            height: '40px',
            borderRadius: '6px',
            backgroundColor: '#3b82f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <FontAwesomeIcon icon={faCheck} style={{ color: 'white', fontSize: '16px' }} />
          </Box>
          <Typography variant="h4" sx={{
            fontWeight: 600,
            color: '#1f2937',
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            letterSpacing: '-0.025em'
          }}>
            Gestion des Chauffeurs
          </Typography>
        </Box>

        <Typography variant="body2" sx={{
          color: '#6b7280',
          fontSize: '14px',
          fontWeight: 500,
          backgroundColor: '#ffffffff',
          padding: '6px 12px',
          borderRadius: '6px',
          border: '1px solid #e5e7eb'
        }}>
          {Chauffeurs.length} chauffeur{Chauffeurs.length !== 1 ? 's' : ''}
        </Typography>
      </Box>

      {/* Action Buttons Section */}
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'space-between' }
      }}>
        {/* Primary Actions */}
        <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {isAllowedAjouterChauffeur == 1 && (
            <ButtonAttribute
              Label="Ajouter"
              action={handleOpen}
              Bgcolor="#3b82f6"
              color="white"
              bgColorHover="#2563eb"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
              hidden={true}

            />
          )}
          {isAllowedModifierChauffeur == 1 && (
            <ButtonAttribute
              Label="Modifier"
              action={handleOpenModifier}
              Bgcolor="#f59e0b"
              color="white"
              bgColorHover="#d97706"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
              hidden={true}

            />
          )}
          {isAllowedSupprimerChauffeur == 1 && (
            <ButtonAttribute
              Label="Supprimer"
              action={handleOpenDeleteChauffeur}
              Bgcolor="#ef4444"
              color="white"
              bgColorHover="#dc2626"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
              hidden={true}

            />
          )}
        </Box>

        {/* Secondary Actions */}
        <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {isAllowedExporterChauffeur == 1 && (
            <ButtonAttribute
              Label="Exporter"
              action={handleOpenExtrationChauffeur}
              Bgcolor="#8b5cf6"
              color="white"
              bgColorHover="#7c3aed"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
              hidden={true}

            />
          )}
          {isAllowedImporterChauffeur == 1 && (
            <ButtonAttribute
              Label="Importer"
              action={handleOpenImportationChauffeur}
              Bgcolor="#10b981"
              color="white"
              bgColorHover="#059669"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
              hidden={true}

            />
          )}
        </Box>
      </Box>
    </Box>
  );

  const columns = [
    { accessorKey: 'id', header: 'ID Chauffeur', size: 120 },
    { accessorKey: 'Nom', header: 'Nom', size: 160 },
    { accessorKey: 'Prénom', header: 'Prénom', size: 160 },
    { accessorKey: 'Numéro_permis', header: 'Numéro de Permis', size: 200 },
    { accessorKey: 'Type_de_permis', header: 'Type de permis', size: 160 },
    { accessorKey: 'Numéro_de_CIN', header: 'Numéro de CIN', size: 160 },
    { accessorKey: 'Date_de_naissance', header: 'Date de naissance', size: 160 },
    { accessorKey: 'Contact', header: 'Contact', size: 140 },
    { accessorKey: 'Contact2', header: 'Contact 2', size: 140 },
    { accessorKey: 'Adresse', header: 'Adresse', size: 220 },
    { accessorKey: 'adresse2', header: 'Adresse 2', size: 220 },
    {
      accessorKey: 'Disponibilité', header: 'Disponibilité', size: 140,
      Cell: ({ cell }) => (Number(cell.getValue()) == 1 ? 'Disponible' : 'Indisponible'),
    },
  ];

  const getPermission = (permissions, section, actionName) => {
    const sectionPermissions = permissions.find((perm) => perm.name === section);
    if (!sectionPermissions) return 0;
    const action = sectionPermissions.actions.find((act) => act.name === actionName);
    return action?.allowed ?? 0;
  };

  useEffect(() => {

    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    localStorage.removeItem('selectedRows');

    if (parsedAuthState?.token) {
      setPermissions(parsedAuthState.permissions);
      setRole(parsedAuthState.user.role.name);
      fetchChauffeurs(parsedAuthState.token);
      const intervalId = setInterval(() => setErrors({ error: false, message: '' }), 10000);
      return () => clearInterval(intervalId);
    } else console.error('Token does not exist');
  }, []);

  const fetchChauffeurs = async (token) => {
    try {
      const response = await axios.get(`${API}/chauffeurs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setChauffeurs(response.data.data);
    } catch (error) {
      console.error('Error fetching Chauffeurs:', error);
      setErrors({ error: true, message: 'Failed to fetch Chauffeurs' });
    }
  };

  const handleAjouterChauffeur = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    const requiredFields = [
      { key: "Nom", label: "Nom" },
      { key: "Prénom", label: "Prénom" },
      { key: "Numéro_permis", label: "Numéro de permis" },
      { key: "Type_de_permis", label: "Type de permis" },
      { key: "Numéro_de_CIN", label: "Numéro de CIN" },
    ];

    const missingFields = requiredFields.filter(
      (f) => !newChauffeur[f.key] || newChauffeur[f.key].toString().trim() === ""
    );

    if (missingFields.length > 0) {
      const message = `Champs obligatoires manquants: ${missingFields
        .map((f) => f.label)
        .join(", ")}`;
      setErrors({ error: true, message });
      return;
    }

    axios
      .post(
        `${API}/chauffeurs`,
        {
          Nom: newChauffeur.Nom,
          Prénom: newChauffeur.Prénom,
          Numéro_permis: newChauffeur.Numéro_permis,
          Contact: newChauffeur.Contact,
          Disponibilité: Number(newChauffeur.Disponibilité) ? 1 : 0,
          Date_de_naissance: newChauffeur.Date_de_naissance || null,
          Type_de_permis: newChauffeur.Type_de_permis,
          Numéro_de_CIN: newChauffeur.Numéro_de_CIN,
          Adresse: newChauffeur.Adresse || null,
          adresse2: newChauffeur.adresse2 || null,
          Contact2: newChauffeur.Contact2 || null,
        },
        { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }
      )
      .then(() => {
        handleClose();
        setAlertOpen(true);
        fetchChauffeurs(parsedAuthState.token);
        logOperation({
          operation_type: "CREATE",
          entity_type: "Chauffeur",
          entity_id: parsedAuthState.user.id,
          description: "Ajout d'un chauffeur",
        });
      })
      .catch((error) => {
        console.error('Create error:', error?.response?.data || error.message);
      });
  };

  const isAllowedAjouterChauffeur = getPermission(Permissions, 'Chauffeurs', 'ajouter Chauffeur');
  const isAllowedModifierChauffeur = getPermission(Permissions, 'Chauffeurs', 'modifier Chauffeur');
  const isAllowedSupprimerChauffeur = getPermission(Permissions, 'Chauffeurs', 'supprimer Chauffeur');
  const isAllowedExporterChauffeur = getPermission(Permissions, 'Chauffeurs', 'exporter Chauffeur');
  const isAllowedImporterChauffeur = getPermission(Permissions, 'Chauffeurs', 'importer Chauffeur');

  return (
    <ThemeProvider theme={theme}>
      {(role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture') ? (
        <Box sx={{
          flexGrow: 1,
          backgroundColor: '#f8fafc',
          padding: { xs: '16px', md: '20px' },
          minHeight: '116vh',
          transition: 'all 0.3s ease-in-out'
        }}>
          <MenuButton />
          <Box sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            overflow: 'hidden'
          }}>
            <DataGridTable data={Chauffeurs} columns={columns} />
          </Box>
        </Box>
      ) : null}

      {/* Ajouter */}
      <BasicModal
        open={openAjouterChauffeur}
        onClose={handleClose}
        ChildrenContent={
          <Box>
            <Typography variant='h4' sx={{ fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' }, mb: 2, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', padding: '20px' }}>
              Nouveau Chauffeur
            </Typography>

            <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', color: '#1D3E62', gap: 1 }} >
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Prénom" type="text" value={newChauffeur.Prénom} setValue={(e) => setNewChauffeur({ ...newChauffeur, Prénom: e })} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Nom" type="text" value={newChauffeur.Nom} setValue={(e) => setNewChauffeur({ ...newChauffeur, Nom: e })} />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Numéro de Permis" type="text" value={newChauffeur.Numéro_permis} setValue={(e) => setNewChauffeur({ ...newChauffeur, Numéro_permis: e })} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <AutocompleteComboBox
                  required
                  Label="Type de permis"
                  widthSpecific="100%"
                  list={typesPermisMA}
                  keyField="id"
                  valueField="Nom"
                  value={newChauffeur.Type_de_permis}
                  onChange={(id) => setNewChauffeur(prev => ({ ...prev, Type_de_permis: id }))}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Numéro de CIN" type="text" value={newChauffeur.Numéro_de_CIN} setValue={(e) => setNewChauffeur({ ...newChauffeur, Numéro_de_CIN: e })} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui
                  label="Date de naissance"
                  type="date"
                  value={newChauffeur.Date_de_naissance ?? maxDob}
                  setValue={(v) =>
                    setNewChauffeur(prev => ({
                      ...prev,
                      Date_de_naissance: (v && v <= maxDob) ? v : maxDob,
                    }))
                  }
                  max={maxDob} // TextInputMui should pass this to the native input
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Adresse" type="text" value={newChauffeur.Adresse} setValue={(e) => setNewChauffeur({ ...newChauffeur, Adresse: e })} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Adresse 2" type="text" value={newChauffeur.adresse2} setValue={(e) => setNewChauffeur({ ...newChauffeur, adresse2: e })} />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                <TextInputMui label="Contact" type="text" value={newChauffeur.Contact} setValue={(e) => setNewChauffeur({ ...newChauffeur, Contact: e })} />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <TextInputMui label="Contact 2" type="text" value={newChauffeur.Contact2} setValue={(e) => setNewChauffeur({ ...newChauffeur, Contact2: e })} />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FormControlLabel
                  sx={{ color: '#1D3E62', ml: 2 }}
                  control={
                    <Switch
                      checked={!!Number(newChauffeur.Disponibilité)}
                      onChange={(e) =>
                        setNewChauffeur({
                          ...newChauffeur,
                          Disponibilité: e.target.checked ? 1 : 0,
                        })
                      }
                      color="success" // use "primary", "secondary", "success", etc.
                    />
                  }
                  label="Disponible"
                />
              </Grid>

              {errors.error === true ? (
                <Typography variant='subtitle1' component="p" sx={{ color: 'red', textAlign: 'center' }}>{errors.message}</Typography>
              ) : null}

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '500px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <ButtonAttribute
                    type="submit" Label="Ajouter" color={'white'} Bgcolor='#28A745' height={'60px'} width={'100%'}
                    action={handleAjouterChauffeur}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        }
      />

      {/* Modifier */}
      <BasicModal
        open={openModifierChauffeur}
        onClose={handleCloseModifier}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box>
              <Typography variant='h4' sx={{ fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' }, mb: 2, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', padding: '20px' }}>
                Modifier Chauffeur ID : {rowsSelected[0].id}
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', color: '#1D3E62', gap: 2 }}>
                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Prénom" type="text" value={modifierChauffeur.Prénom}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Prénom: v }))} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Nom" type="text" value={modifierChauffeur.Nom}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Nom: v }))} />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Numéro de Permis" type="text" value={modifierChauffeur.Numéro_permis}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Numéro_permis: v }))} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <AutocompleteComboBox
                      required
                      Label="Type de permis"
                      widthSpecific="100%"
                      list={typesPermisMA}
                      keyField="id"
                      valueField="Nom"
                      value={modifierChauffeur.Type_de_permis}
                      onChange={(id) => setModifierChauffeur(prev => ({ ...prev, Type_de_permis: id }))}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Numéro de CIN" type="text" value={modifierChauffeur.Numéro_de_CIN}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Numéro_de_CIN: v }))} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Date de naissance" type="date" value={modifierChauffeur.Date_de_naissance || ''}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Date_de_naissance: v }))} />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Adresse" type="text" value={modifierChauffeur.Adresse}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Adresse: v }))} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Adresse 2" type="text" value={modifierChauffeur.adresse2}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, adresse2: v }))} />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                    <TextInputMui label="Contact" type="text" value={modifierChauffeur.Contact}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Contact: v }))} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <TextInputMui label="Contact 2" type="text" value={modifierChauffeur.Contact2}
                      setValue={(v) => setModifierChauffeur((p) => ({ ...p, Contact2: v }))} />
                  </Grid>

                  <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                    <FormControlLabel
                      sx={{ mt: 1 }}
                      control={
                        <Switch
                          checked={Number(modifierChauffeur.Disponibilité) === 1}
                          onChange={(e) =>
                            setModifierChauffeur({
                              ...modifierChauffeur,
                              Disponibilité: e.target.checked ? 1 : 0,
                            })
                          }
                          color="success"
                        />
                      }
                      label="Disponibilité"
                    />
                  </Grid>

                  {errorsModifer.error && (
                    <Typography sx={{ color: 'red', textAlign: 'center', mt: 1 }}>
                      {errorsModifer.message}
                    </Typography>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '500px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <ButtonAttribute
                        type="submit" Label="Modifier Chauffeur" color={'white'} Bgcolor='#28A745' height={'60px'} width={'100%'}
                        action={handleOpenModifierOneChauffeur}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ) : (
            <Typography variant='h4' sx={{ fontSize: { lg: '20px', md: '20px', sm: '20px', xs: '20px' }, mb: 2, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: '600', padding: '20px' }}>
              Opération invalide. Les modifications multiples ne sont pas autorisées.
            </Typography>
          )
        }
      />

      {/* Supprimer */}
      <BasicModal
        open={openDeleteChauffeur}
        onClose={handleCloseDeleteChauffeur}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box>
              <Typography variant='h4' sx={{ fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' }, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', padding: '10px' }}>
                Suppression de la Chauffeur ID : {rowsSelected[0].id}
              </Typography>
              <Typography variant='h6' sx={{ fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' }, mb: 1, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', padding: '20px' }}>
                Voulez-vous vraiment supprimer cette Chauffeur ?
              </Typography>
              <Box sx={{ display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' }, justifyContent: 'space-evenly', alignItems: 'center', gap: '20px' }}>
                <ButtonAttribute type="submit" Label="Annuler" color={'white'} Bgcolor='gray' height={'50px'} width={'100%'} action={handleCloseDeleteChauffeur} />
                <ButtonAttribute type="submit" Label="Supprimer" color={'white'} Bgcolor='#DC3545' height={'50px'} width={'100%'} action={handleOpenConfirmationPassword} />
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography variant='h4' sx={{ fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' }, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', padding: '10px' }}>
                Suppression des Chauffeurs sélectionnées
              </Typography>
              <Typography variant='h6' sx={{ fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' }, mb: 1, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', padding: '20px' }}>
                Voulez-vous vraiment supprimer toutes les Chauffeurs sélectionnées ?
              </Typography>

              {rowsSelected.length > 1 ? (
                <Box sx={{ justifyContent: "center", display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', marginBottom: '20px' }}>
                  {rowsSelected.map((row, index) => (
                    <Box key={index} sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', marginBottom: '20px', padding: '10px', width: '50px', height: '40px', borderRadius: '10%', backgroundColor: '#DC3545', }}>
                      <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
                        {row.id || 'N/A'}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : null}

              <Box sx={{ display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' }, justifyContent: 'space-evenly', alignItems: 'center', gap: '20px' }}>
                <ButtonAttribute type="submit" Label="Annuler" color={'white'} Bgcolor='gray' height={'50px'} width={'100%'} action={handleCloseDeleteChauffeur} />
                <ButtonAttribute type="submit" Label="Supprimer toutes" color={'white'} Bgcolor='#DC3545' height={'50px'} width={'100%'} action={handleOpenConfirmationPassword} />
              </Box>
            </Box>
          )
        }
      />

      {/* Export */}
      <BasicModal
        open={openExtrationChauffeur}
        onClose={handleCloseExtrationChauffeur}
        ChildrenContent={
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: "35px", md: "30px", sm: "25px", xs: "20px" },
                fontFamily: "Montserrat, sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                fontWeight: "bold",
                padding: "10px",
              }}
            >
              Exportation des données Chauffeurs
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { lg: "20px", md: "16px", sm: "14px", xs: "14px" },
                mb: 1,
                fontFamily: "Montserrat, sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                padding: "20px",
              }}
            >
              Sélectionnez le mode d’exportation souhaité au format Excel (.xlsx).
            </Typography>
            <Box sx={{ display: "grid", alignItems: "center", gap: "10px" }}>
              <ButtonAttribute
                type="button"
                Label="Exporter toutes les données (Excel)"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover="#117A8B"
                height="70px"
                width="100%"
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                action={handleExtrationAllChauffeur}
              />

              <ButtonAttribute
                type="button"
                Label="Exporter les lignes sélectionnées (Excel)"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover="#117A8B"
                height="70px"
                width="100%"
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                action={handleExtrationSelectionsChauffeurs}
              />
            </Box>
          </Box>
        }
      />

      {/* Import */}
      <BasicModal
        open={openImportationChauffeur}
        onClose={handleCloseImportationChauffeur}
        ChildrenContent={
         <Box sx={{ px: 3, py: 2 }}>

  {/* ===== Title ===== */}
  <Typography
    variant="h4"
    sx={{
      fontSize: { lg: 34, md: 28, sm: 24, xs: 20 },
      fontFamily: "Montserrat, sans-serif",
      color: "#1D3E62",
      textAlign: "center",
      fontWeight: 700,
      mb: 1,
    }}
  >
    Importation des Chauffeurs
  </Typography>

  {/* ===== Subtitle ===== */}
  <Typography
    variant="body1"
    sx={{
      fontSize: { md: 16, sm: 14, xs: 13 },
      color: "#6B7280",
      textAlign: "center",
      mb: 3,
    }}
  >
    Téléchargez le modèle Excel, complétez les informations nécessaires,
    puis importez votre fichier pour ajouter plusieurs chauffeurs.
  </Typography>

  {/* ===== Download Section ===== */}
  <Box
    sx={{
      p: 2,
      mb: 3,
      borderRadius: "12px",
      border: "1px solid #E5E7EB",
      backgroundColor: "#F9FAFB",
    }}
  >
    <ButtonAttribute
      type="button"
      Label="Télécharger le modèle Excel"
      Bgcolor="#2563EB"
      color="white"
      bgColorHover="#1D4ED8"
      height="60px"
      width="100%"
      endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
      action={handleDownload}
    />
  </Box>

  {/* ===== Upload Section ===== */}
  <Box
    sx={{
      p: 2,
      borderRadius: "12px",
      border: "1px solid #E5E7EB",
      backgroundColor: "#FFFFFF",
    }}
  >
    <Typography
      variant="subtitle1"
      sx={{
        textAlign: "center",
        mb: 2,
        fontWeight: 600,
        color: "#1D3E62",
      }}
    >
      Sélectionnez votre fichier Excel
    </Typography>

    <ButtonAttribute
      type="button"
      Label="Importer les chauffeurs"
      Bgcolor="#10B981"
      color="white"
      bgColorHover="#059669"
      height="60px"
      width="100%"
      endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color="white" />}
      action={triggerFileInput}
    />

    <input
      id="file-upload"
      type="file"
      accept=".xlsx, .xls, .csv"
      style={{ display: "none" }}
      onChange={handleFileImport}
    />

    {/* ===== Progress Bar ===== */}
    <Box sx={{ mt: 3 }}>
      <CustomizedProgressBars
        value={isLoading}
        color={
          importStatus === "success"
            ? "success"
            : importStatus === "error"
            ? "error"
            : importStatus === "processing"
            ? "primary"
            : "gray"
        }
      />
    </Box>
  </Box>
</Box>
        }
      />

      {/* Confirmation mot de passe */}
      <BasicModal
        open={openConfirmationPassword}
        onClose={handleCloseConfirmationPassword}
        ChildrenContent={
          <Box>
            <Typography variant='h4' sx={{ fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' }, fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', padding: '20px', marginBottom: '20px' }}>
              Saisissez votre mot de passe pour confirmer la suppression
            </Typography>
            <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
              <TextInputMui type="password" label="Mot de passe" name="password" value={ConfrimedPassword.password} setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })} required />
              <ButtonAttribute type="submit" Label="Confirmer la suppression" Bgcolor='#17A2B8' color='white' bgColorHover={'#117A8B'} height={'50px'} width={'100%'} endIcon={<FontAwesomeIcon icon={faCheck} color='white' />} action={handleVerificationPassword} />
            </Box>
          </Box>
        }
      />

      {/* Alerts */}
      <AlertBar open={alertOpen} onClose={handleAlertClose} textContent="La Chauffeur a été ajoutée avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenSelectedModifier} onClose={handleAlertCloseSelectedModifier} textContent="Veuillez choisir une ligne" alertColor="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenNotModiferRow} onClose={handleAlertCloseNotModiferRow} textContent={"Aucune information modifiée."} alertColor={"info"} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
      <AlertBar open={alertOpenUpdatedChauffeur} onClose={handleAlertCloseUpdatedChauffeur} textContent="Chauffeur mise à jour avec succès" alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenDeletedChauffeur} onClose={handleAlertCloseDeletedChauffeur} textContent="Chauffeur supprimée avec succès" alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenPasswordNotValid} onClose={handleAlertClosePasswordNotValid} textContent="Mot de passe incorrect pour supprimer la Chauffeur" alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenMultiDeletedChauffeur} onClose={handleAlertMultiCloseDeletedChauffeur} textContent="Toutes les Chauffeurs ont été supprimées avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenNotSelectedLineExtration} onClose={handleAlertCloseNotSelectedLineExtration} textContent={"Sélectionnez des lignes à extraire."} alertColor={"info"} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
      <AlertBar open={alertOpenImport} onClose={handleCloseAlertImport} textContent="Importation effectuée avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertErrorImport} onClose={handleCloseErrorAlertImport} textContent="Importation non effectuée. Vérifiez les valeurs." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
      <AlertBar open={alertOpenConfirmDeleteChauffeur} onClose={handleCloseAlertConfirmDeleteChauffeur} textContent="Le mot de passe est incorrect." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
    </ThemeProvider>
  );
}
